import { defineComponent as _defineComponent } from 'vue'
import { IHawkSuggestionTrackingData } from 'Src/js/types/HawkSearch';
import { onMounted, onUnmounted } from 'vue';
import {
	SearchAutocompleteResult,
	SearchAutocompleteResultItem,
	SearchAutocompleteResultProduct
} from 'JS/header/services/SearchAutocompleteService';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSuggestions',
  props: {
    suggestions: null,
    keyword: { default: '' },
    testGroup: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { suggestions: SearchAutocompleteResult, keyword: string, testGroup: number }



onMounted(() => {
	document.body.classList.add('shadowed');
});
onUnmounted(() => {
	document.body.classList.remove('shadowed');
});

function trackAutoSuggestCategory(category: SearchAutocompleteResultItem, suggestType: number) {
	doTrackAutoSuggest({
		keyword: props.keyword,
		suggestType: suggestType,
		name: category.html,
		itemUrl: category.url
	});
}

function trackAutoSuggestProduct(product: SearchAutocompleteResultProduct) {
	doTrackAutoSuggest({
		keyword: props.keyword,
		suggestType: 3,
		name: `${product.vendorBrand} ${product.name}`,
		itemUrl: product.url
	});
}

function doTrackAutoSuggest(event: IHawkSuggestionTrackingData) {
	window.blainGtmDataLayer.push({
		'searchKeyword': event.keyword,
		'searchAutocompleteSuggestType': event.suggestType,
		'searchAutocompleteName': event.name,
		'searchAutocompleteItemUrl': event.itemUrl,
		'event': 'search_autocomplete_click'
	});
}

/**
 * Website URL subdomain from Hawk won't necessarily match that of the current environment.
 * This attempts to make them relative, so that suggestion link subdomains don't take you to
 * a different env.
 */
function relativeUrl(originalUrl: string): string {
	try {
		const url = new URL(originalUrl);
		const isFirstParty = url.host === 'farmandfleet.com' || url.host.endsWith('.farmandfleet.com');
		if (!isFirstParty) {
			return originalUrl;
		}

		return url.href.replace(`${url.protocol}//${url.host}`, '');
	} catch (e) {
		return originalUrl;
	}
}

return { __sfc: true,props, trackAutoSuggestCategory, trackAutoSuggestProduct, doTrackAutoSuggest, relativeUrl }
}

})